import { render, staticRenderFns } from "./square.vue?vue&type=template&id=09650d8a&"
import script from "./square.vue?vue&type=script&lang=js&"
export * from "./square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports